<section class="px-0 sm:px-[6.3%] mb-8 lg:mb-12 3xl:mb-16">
    <div class="relative p-8 lg:p-12 3xl:p-16 flex gap-8 lg:gap-14 3xl:gap-[59px] flex-col lg:flex-col justify-between">
        <video class="absolute inset-0 w-full h-full object-cover sm:rounded-xl 3xl:rounded-2xl" loop muted autoplay
            oncanplay="this.play()" onloadedmetadata="this.muted = true">
            <source src="assets/hero/rebot.mp4" type="video/mp4">
        </video>
        <div
            class="absolute inset-0  bg-gradient-to-t from-dark-gray1 to-dark-gray1 mix-blend-hard-light sm:rounded-xl 3xl:rounded-2xl">
        </div>
        <div class="w-full lg:w-[70%] 2xl:w-[75%] relative z-10">
            <h1
                class="lg:px-2 3xl:px-3 text-white text-3xl sm:text-4xl lg:text-5xl 2xl:text-6xl 3xl:text-7xl font-bold sm:leading-[43px] lg:leading-[60px] 2xl:leading-[70px] 3xl:leading-[84px] lg:mt-16 3xl:mt-20 w-full sm:w-3/5 lg:w-full">
                Powering the Future of Next Generation Electronics Design and Manufacturing</h1>
        </div>
        <div class="w-full lg:pl-[62%] z-10 mb-2 3xl:mb-4">
            <h2 class="text-white font-light text-sm 3xl:text-lg  mb-6 3xl:mb-8 max-w-[18rem] 3xl:max-w-sm">
                We excel at bringing products to market swiftly while staying
                ahead of the curve in material science and advanced assembly techniques. Let’s innovate and scale
                together!
            </h2>
            <app-button [size]="'large'" heading="Learn more" routerLink="/services"
                icon="assets/shared/r-arrow.svg"></app-button>
        </div>
    </div>
</section>